/* ============================================================
   Geraete-Beigaben: liegt ein Igloo-Geraet im Warenkorb, kommen
   automatisch mit 0,00 EUR dazu - je Geraet ein Satz:

     - die vier Standard-Adapter (WizBiotech, Lansionbio, Unimed,
       Orient Gene - Orient Gene seit 08.10.2026, Entscheidung Sales:
       gleicher Preis und gleiche Regeln wie WizBiotech)
     - die QC-Kalibrierungskassette
     - NUR zum Igloo Reader Pro DC zusaetzlich der Konsung-Adapter
       (Lipid-Panel + Glukose), je DC einer

   Fachliche Regeln (Sales, 10.09.2026, ergaenzt 05.10.2026):
   - 2 Igloos  -> je Position Menge 2, alles kostenfrei
   - kein Geraet mehr im Warenkorb -> die kostenlosen Positionen
     fliegen automatisch wieder raus (NICHT auf den regulaeren Preis
     umstellen - der Kunde hat sie nie ausgewaehlt)
   - KONSUNG (Stand 05.10.2026, gilt im normalen Shop UND in allen
     Partnerbereichen gleich): kostenlos zu jedem Igloo Reader Pro DC.
     Der Adapter wird auf das Geraet und dessen Seriennummer abgestimmt
     und ist darum NICHT nachbestellbar. Die regulaere Variante (60 EUR)
     bleibt im Katalog, wird aber aus jedem Warenkorb entfernt.
     Bei Beschaedigung/Verlust: Kontakt ueber Kundenbetreuung@goodscare.com.
     Texte dazu: GC_KONSUNG_TEXT unten, snippets/cart-line.liquid,
     sections/zubehoer-grid.liquid, sections/main-product-testkit.liquid.
   - QC-Kassette ist NICHT einzeln bestellbar. Sie hat nur eine
     Variante zu 0,00 EUR, steht in keinem Grid und bleibt auf Status
     UNLISTED. Wer sie doch ueber die Direkt-URL in den Warenkorb legt,
     bekommt sie beim naechsten Warenkorb-Ereignis wieder entfernt,
     solange kein Geraet dabei ist - genau wie die Adapter.

   Warum eine eigene Funktion und keine Erweiterung von
   gcEnforcePosFreebie(): die Bedingungen sind unterschiedlich. POS
   braucht 1 Geraet UND 3 Testboxen und tauscht zwischen bezahlter und
   kostenloser Variante. Diese Beigaben haengen nur am Geraet und werden
   von der Automatik selbst hinzugefuegt bzw. entfernt.

   Bezahlte Zeilen der vier Standard-Adapter bleiben unangetastet (wer
   zusaetzlich Adapter zum regulaeren Preis im Korb hat, behaelt sie).
   Ausnahme Konsung: die bezahlte Variante wird entfernt, weil sie nicht
   mehr nachbestellt werden kann.

   Anbindung: die Datei wird in layout/theme.liquid NACH theme.js
   geladen und legt sich um gcEnforcePosFreebie(). Deren Aufrufe in
   theme.js (gcAddItemsToCart, gcApplyCartChange) laufen ueber den
   globalen Namen, greifen also automatisch die umhuellte Fassung ab.
   gc-partner-mode.js ruft gcEnforceAdapterFreebie() im Partnermodus
   direkt auf - die Konsung-Regel gilt dort also identisch.

   Zusaetzlich (05.10.2026): Hinweisblock "Adapter - kostenlos dazu" in
   allen Neukunden-Rechnern (Starterkit, Dental, Startbonus, Aposanitas)
   und ein Hinweis im Nachbestellungs- und im Partner-Rechner. Rein per
   DOM, damit die Rechner-Dateien nicht angefasst werden muessen.
   ============================================================ */
(function(){
  'use strict';

  /* Kostenlose Beigaben zum Geraet.
     paid = regulaere Variante (nur zur Doku, wird nicht angefasst),
     free = Variante zu 0,00 EUR, die die Automatik setzt,
     dcOnly = nur zum Igloo Reader Pro DC.
     Die QC-Kassette hat nur EINE Variante, die immer 0,00 EUR kostet. */
  var GC_GERAETE_BEIGABEN = {
    wizbiotech:  { paid: 59093577466181, free: 59264665813317 },
    lansionbio:  { paid: 59093580448069, free: 59264665846085 },
    unimed:      { paid: 59093583233349, free: 59264665878853 },
    orient_gene: { paid: 59615082381637, free: 59615082414405 },
    qc_kassette: { paid: null,           free: 59293692264773 },
    konsung:     { paid: 59093586313541, free: 59582699077957, dcOnly: true }
  };

  /* Igloo | Reader Pro DC */
  var GC_DC_VARIANT = 59065942540613;
  var GC_DC_HANDLE  = 'gc-igloo-reader-pro-dc';

  var GC_KONSUNG_MAIL = 'Kundenbetreuung@goodscare.com';
  var GC_KONSUNG_TEXT = 'Der Konsung-Adapter wird auf Ihr Igloo und dessen Seriennummer abgestimmt und kann deshalb nicht nachbestellt werden. Ist er beschädigt oder verlegt, melden Sie sich bitte unter ' + GC_KONSUNG_MAIL + '.';
  window.gcKonsungText = GC_KONSUNG_TEXT;

  function gcRoot(){
    if(window.Shopify && window.Shopify.routes && window.Shopify.routes.root){
      return window.Shopify.routes.root;
    }
    return '/';
  }

  async function gcCartChange(id, quantity){
    return fetch(gcRoot() + 'cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: id, quantity: quantity })
    });
  }

  async function gcCartAdd(variantId, quantity){
    return fetch(gcRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    });
  }

  function isDc(item){
    return item.variant_id === GC_DC_VARIANT || item.handle === GC_DC_HANDLE;
  }

  async function gcEnforceAdapterFreebie(){
    try{
      var res = await fetch(gcRoot() + 'cart.js');
      var cart = await res.json();

      /* Geraete zaehlen - dieselbe Erkennung wie bei POS und Staffel:
         ueber den Produkttyp, nicht ueber Varianten-IDs. Der DC wird
         fuer den Konsung-Adapter zusaetzlich einzeln gezaehlt. */
      var deviceQty = 0;
      var dcQty = 0;
      cart.items.forEach(function(item){
        if(item.product_type === 'Geraet') deviceQty += item.quantity;
        if(isDc(item)) dcQty += item.quantity;
      });

      var changed = false;

      /* Konsung ist nicht nachbestellbar: bezahlte Zeilen entfernen */
      var paidKonsung = cart.items.filter(function(i){ return i.variant_id === GC_GERAETE_BEIGABEN.konsung.paid; });
      for(var p = 0; p < paidKonsung.length; p++){
        await gcCartChange(paidKonsung[p].key, 0);
        changed = true;
      }
      if(paidKonsung.length && typeof gcShowError === 'function'){
        gcShowError(dcQty > 0
          ? 'Den Konsung-Adapter erhalten Sie zum Igloo Reader Pro DC kostenlos – er wurde automatisch ergänzt.'
          : 'Der Konsung-Adapter kann nicht nachbestellt werden. Ist er beschädigt oder verlegt, melden Sie sich bitte unter ' + GC_KONSUNG_MAIL + '.');
      }
      if(paidKonsung.length){
        res = await fetch(gcRoot() + 'cart.js');
        cart = await res.json();
      }

      for(var key in GC_GERAETE_BEIGABEN){
        var pair = GC_GERAETE_BEIGABEN[key];
        var target = pair.dcOnly ? dcQty : deviceQty;
        var freeLine = cart.items.find(function(i){ return i.variant_id === pair.free; });
        var haveFree = freeLine ? freeLine.quantity : 0;

        if(target > 0){
          /* Sollmenge = Anzahl (passender) Geraete. */
          if(haveFree !== target){
            if(freeLine){
              await gcCartChange(freeLine.key, target);
            } else {
              await gcCartAdd(pair.free, target);
            }
            changed = true;
          }
        } else if(freeLine){
          /* Kein (passendes) Geraet mehr da - kostenlose Beigaben
             entfernen, nicht auf einen regulaeren Preis umstellen. Bei der
             QC-Kassette ist das zugleich die Sperre gegen Einzelbestellungen. */
          await gcCartChange(freeLine.key, 0);
          changed = true;
        }
      }

      if(changed && typeof gcRefreshCartSection === 'function'){
        await gcRefreshCartSection();
      }
      if(changed && typeof gcUpdateCartBadge === 'function'){
        await gcUpdateCartBadge();
      }
    } catch(err){
      console.error('Beigaben-Check fehlgeschlagen:', err);
    }
  }

  window.gcEnforceAdapterFreebie = gcEnforceAdapterFreebie;

  /* ------------------------------------------------------------
     An gcEnforcePosFreebie() anhaengen. theme.js ruft die Funktion
     nach jeder Warenkorbaenderung auf; weil der Aufruf ueber den
     globalen Namen laeuft, wird hier die umhuellte Fassung erreicht.
     Ohne diesen Umweg muesste theme.js angefasst werden.
     ------------------------------------------------------------ */
  if(typeof window.gcEnforcePosFreebie === 'function' && !window.gcEnforcePosFreebie._gcAdapterWrapped){
    var original = window.gcEnforcePosFreebie;
    var wrapped = async function(){
      await original.apply(this, arguments);
      await gcEnforceAdapterFreebie();
    };
    wrapped._gcAdapterWrapped = true;
    window.gcEnforcePosFreebie = wrapped;
  } else if(typeof window.gcEnforcePosFreebie !== 'function'){
    console.warn('gc-adapter-freebie.js: gcEnforcePosFreebie nicht gefunden - laedt die Datei vor theme.js?');
  }

  /* ------------------------------------------------------------
     Rechner: Hinweisblock "Adapter - kostenlos dazu"
     ------------------------------------------------------------ */
  function el(tag, cls, text){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    if(text) n.textContent = text;
    return n;
  }
  function adapterRow(label, meta, cls){
    var row = el('div', 'cfg-row' + (cls ? ' ' + cls : ''));
    var info = el('div', 'cfg-info');
    info.appendChild(el('div', 'cfg-label', label));
    if(meta){
      var m = el('div', 'cfg-meta', meta);
      m.style.lineHeight = '1.5';
      info.appendChild(m);
    }
    var right = el('div', 'cfg-right');
    right.appendChild(el('span', 'cfg-total', 'inklusive'));
    row.appendChild(info);
    row.appendChild(right);
    return row;
  }
  function findLabel(root, startsWith){
    return Array.prototype.find.call(root.querySelectorAll('.section-label'), function(s){
      return s.textContent.trim().indexOf(startsWith) === 0;
    });
  }
  function prevDivider(node){
    var p = node && node.previousElementSibling;
    return (p && p.classList.contains('divider')) ? p : node;
  }
  function noteBox(text){
    var n = el('div', 'gc-konsung-note', text);
    n.style.cssText = 'font-size:11px;color:rgba(255,255,255,0.6);line-height:1.55;margin:0 0 10px;';
    return n;
  }

  /* Neukunden-Rechner (Starterkit/Dental, Startbonus, Aposanitas) */
  function decorateNewCustomerRoot(root){
    if(root.querySelector('.gc-adapter-incl')) return;
    var anchorLabel = findLabel(root, 'POS-Material');
    var anchor = anchorLabel ? prevDivider(anchorLabel) : null;
    if(!anchor){
      var bd = root.querySelector('[id$="breakdown"]');
      anchor = bd ? prevDivider(bd) : null;
    }
    if(!anchor || !anchor.parentNode) return;

    var wrap = el('div', 'gc-adapter-incl');
    wrap.appendChild(el('div', 'divider'));
    wrap.appendChild(el('div', 'section-label', 'Adapter · kostenlos dazu'));
    wrap.appendChild(noteBox('Zu Ihrem Igloo erhalten Sie die passenden Adapter und die QC-Kalibrierungskassette kostenlos. Sie werden im Warenkorb automatisch ergänzt.'));
    ['Adapter | WizBiotech', 'Adapter | Lansionbio', 'Adapter | Unimed', 'Adapter | Orient Gene', 'QC-Kalibrierungskassette'].forEach(function(a){
      wrap.appendChild(adapterRow(a));
    });
    wrap.appendChild(adapterRow('Adapter | Konsung', 'Nur zum Igloo Reader Pro DC (für Lipid-Panel + Glukose). ' + GC_KONSUNG_TEXT, 'gc-konsung-row'));
    anchor.parentNode.insertBefore(wrap, anchor);

    /* Konsung-Zeile nur beim DC zeigen. Pro gewaehlt = Geraete-Hinweis
       (id endet auf device-note) ist sichtbar bzw. Label nennt das
       Vorgaengermodell. */
    var konsung = wrap.querySelector('.gc-konsung-row');
    var devNote = root.querySelector('[id$="device-note"]');
    var devLabel = root.querySelector('[id$="device-label"]');
    function sync(){
      var isPro = (devNote && devNote.classList.contains('show')) ||
                  (devLabel && /Vorgängermodell/.test(devLabel.textContent));
      konsung.style.display = isPro ? 'none' : '';
    }
    sync();
    if(window.MutationObserver){
      var mo = new MutationObserver(sync);
      if(devNote) mo.observe(devNote, { attributes: true, attributeFilter: ['class'] });
      if(devLabel) mo.observe(devLabel, { childList: true, characterData: true, subtree: true });
    }
  }

  /* Partner-Rechner: Liste steht schon dort, Konsung-Zeile ergaenzen */
  function decoratePartnerRoot(root){
    if(root.querySelector('.gc-konsung-meta')) return;
    Array.prototype.forEach.call(root.querySelectorAll('.cfg-row .cfg-label'), function(l){
      if(l.textContent.trim() !== 'Adapter | Konsung') return;
      var m = el('div', 'cfg-meta gc-konsung-meta', GC_KONSUNG_TEXT);
      m.style.lineHeight = '1.5';
      l.parentNode.appendChild(m);
    });
  }

  /* Nachbestellung: Hinweis, dass Konsung nicht nachbestellbar ist */
  function decorateReorderRoot(root){
    if(root.querySelector('.gc-adapter-incl')) return;
    var bd = root.querySelector('[id$="breakdown"]');
    var anchor = bd ? prevDivider(bd) : null;
    if(!anchor || !anchor.parentNode) return;
    var wrap = el('div', 'gc-adapter-incl');
    wrap.appendChild(el('div', 'divider'));
    wrap.appendChild(el('div', 'section-label', 'Adapter'));
    var n = noteBox('');
    n.innerHTML = 'Die Standard-Adapter können Sie unter <a href="/pages/zubehor" style="color:inherit;text-decoration:underline;">Zubehör</a> nachbestellen. Der Konsung-Adapter (Lipid-Panel + Glukose) wird auf Ihr Igloo und dessen Seriennummer abgestimmt und kann nicht nachbestellt werden. Ist er beschädigt oder verlegt, melden Sie sich bitte unter <a href="mailto:' + GC_KONSUNG_MAIL + '" style="color:inherit;text-decoration:underline;">' + GC_KONSUNG_MAIL + '</a>.';
    wrap.appendChild(n);
    anchor.parentNode.insertBefore(wrap, anchor);
  }

  function decorateConfigurators(){
    ['gc-starterkit-root', 'gcb-starterkit-root'].forEach(function(id){
      var r = document.getElementById(id);
      if(r) decorateNewCustomerRoot(r);
    });
    var p = document.getElementById('gcp-root');
    if(p) decoratePartnerRoot(p);
    var n = document.getElementById('gcr-reorder-root');
    if(n) decorateReorderRoot(n);
    /* Uebrige Rechner (z. B. Aposanitas) generisch: jede Rechner-Karte
       mit Geraete-Zeile, die noch keinen Block hat */
    document.querySelectorAll('.configurator-section .gc-starterkit').forEach(function(r){
      if(r.id === 'gcp-root' || r.id === 'gcr-reorder-root') return;
      if(!r.querySelector('.fixed-row')) return;
      decorateNewCustomerRoot(r);
    });
  }

  /* Beim Seitenaufruf mitlaufen, aber nur unter denselben Bedingungen
     wie die uebrigen Warenkorb-Pruefungen (W-16). */
  document.addEventListener('DOMContentLoaded', function(){
    try{ decorateConfigurators(); }catch(e){ console.error('Adapter-Hinweis Rechner:', e); }
    if(typeof gcShouldRunCartChecks === 'function' && !gcShouldRunCartChecks()) return;
    gcEnforceAdapterFreebie();
  });
})();
